import { createTheme } from '../utils/createTheme';
// Create default global light theme
export default createTheme(function () {
  return {
    mode: 'light'
  };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/theme/dist/esm/components/Theme.js
// module id = 183
// module chunks = 0